import script from "./WineItem.vue?vue&type=script&setup=true&lang=js"
export * from "./WineItem.vue?vue&type=script&setup=true&lang=js"

import "./WineItem.vue?vue&type=style&index=0&id=8c35a92e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c35a92e"]])

export default __exports__